var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    { staticClass: "content-article", attrs: { id: "mplus-entrance" } },
    [
      _c("h1", { staticClass: "screen_out" }, [_vm._v("대문 미디어 컨텐츠")]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.wrapClassName },
        _vm._l(_vm.layers, function (layer) {
          return _c(layer.type + "-layer", {
            tag: "component",
            attrs: {
              layer: layer,
              type: _vm.type,
              baseFontColor: _vm.baseFontColor,
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }